(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sh-head"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.shdSpacingRun) return;

  /* Khaas gap wali jagah: abhi koi nahi, poore page par ek jaisa gap.
     Kisi section ka alag gap chahiye to aise likho:
     var CUSTOM = [ { sel: '.rk', d: 20, m: 10 } ];  (sel = us section ka class, d = desktop px, m = mobile px) */
  var CUSTOM = [];

  var SKIP = /^(script|style|link|meta|noscript|template|br|wbr|source|track|param)$/;
  var MEDIA = /^(img|svg|video|canvas|iframe|input|textarea|select)$/;

  function hasText(el) {
    var n = el.childNodes;
    for (var i = 0; i < n.length; i++) {
      if (n[i].nodeType === 3 && n[i].textContent.trim()) return true;
    }
    return false;
  }

  function painted(el) {
    var cs = getComputedStyle(el);
    var bg = cs.backgroundColor;
    if (bg && bg !== 'transparent' && !/^rgba\(\s*0,\s*0,\s*0,\s*0\s*\)$/.test(bg)) return true;
    if (cs.backgroundImage && cs.backgroundImage !== 'none') return true;
    if (cs.boxShadow && cs.boxShadow !== 'none') return true;
    return false;
  }

  /* chhupa hua element (opacity 0 / visibility hidden / display none) naap mein nahi ginna.
     Sirf wow/fadeIn animation wale cards ginte hain (wo scroll par dikhte hain). */
  function isVisible(el, sec) {
    if (el.closest('.wow, [data-wow-delay]')) return true;
    if (typeof el.checkVisibility === 'function') {
      return el.checkVisibility({ opacityProperty: true, visibilityProperty: true, checkOpacity: true, checkVisibilityCSS: true });
    }
    var cs = getComputedStyle(el);
    if (cs.visibility === 'hidden' || cs.display === 'none') return false;
    for (var n = el; n && n !== sec; n = n.parentElement) {
      if (parseFloat(getComputedStyle(n).opacity) === 0) return false;
    }
    return true;
  }

  /* jo hissa kisi parent ke overflow se kat gaya (chhupa hua tab/slide), wo naap mein nahi ginna */
  function clipRange(el, r, sec) {
    var top = r.top, bottom = r.bottom;
    for (var p = el.parentElement; p && p !== sec; p = p.parentElement) {
      var oy = getComputedStyle(p).overflowY;
      if (oy !== 'visible') {
        var pr = p.getBoundingClientRect();
        if (pr.top > top) top = pr.top;
        if (pr.bottom < bottom) bottom = pr.bottom;
        if (bottom - top < 2) return null;
      }
    }
    return { top: top, bottom: bottom };
  }

  function describe(el) {
    if (!el) return '-';
    var c = (typeof el.className === 'string' && el.className) ? '.' + el.className.trim().split(/\s+/).join('.') : '';
    return el.tagName.toLowerCase() + (el.id ? '#' + el.id : '') + c;
  }

  function bounds(sec) {
    var sr = sec.getBoundingClientRect();
    var top = Infinity, bottom = -Infinity, topEl = null, bottomEl = null;
    var all = sec.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      var tag = el.tagName.toLowerCase();
      if (SKIP.test(tag) || el.ownerSVGElement) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 2 || r.height < 2) continue;
      if (r.bottom <= sr.top || r.top >= sr.bottom) continue;
      if (!(MEDIA.test(tag) || hasText(el) || painted(el))) continue;
      if (!isVisible(el, sec)) continue;
      var c = clipRange(el, r, sec);
      if (!c) continue;
      if (c.top < top) { top = c.top; topEl = el; }
      if (c.bottom > bottom) { bottom = c.bottom; bottomEl = el; }
    }
    return top === Infinity ? null : { top: top, bottom: bottom, topEl: topEl, bottomEl: bottomEl };
  }

  function gapFor(sec, mobile) {
    for (var i = 0; i < CUSTOM.length; i++) {
      if (sec.querySelector(CUSTOM[i].sel)) return mobile ? CUSTOM[i].m : CUSTOM[i].d;
    }
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--shd-top'));
    return isNaN(v) ? (mobile ? 60 : 120) : v;
  }

  var LAST = [];

  function run() {
    var root = document.getElementById('MainContent') || document.querySelector('main');
    if (!root) return;
    var html = document.documentElement;
    try {
      html.classList.add('shd-js');
      var secs = [].slice.call(root.querySelectorAll('.shopify-section')).filter(function (s) {
        return !s.parentElement.closest('.shopify-section');
      });
      secs.forEach(function (s) { s.style.removeProperty('margin-top'); });

      var mobile = window.innerWidth < 750;
      var prev = null, jobs = [];
      LAST = [];
      secs.forEach(function (s, idx) {
        if (!s.offsetHeight) return;
        var b = bounds(s);
        if (!b) return;
        LAST[idx] = { id: s.id, topEl: describe(b.topEl), bottomEl: describe(b.bottomEl) };
        if (prev) {
          var cur = parseFloat(getComputedStyle(s).marginTop) || 0;
          jobs.push([s, cur + gapFor(s, mobile) - (b.top - prev.bottom)]);
        }
        prev = b;
      });
      jobs.forEach(function (j) {
        j[0].style.setProperty('margin-top', Math.max(0, j[1]) + 'px', 'important');
      });
    } catch (e) {
      html.classList.remove('shd-js');
    }
  }

  var timer;
  function later(ms) { clearTimeout(timer); timer = setTimeout(run, ms || 120); }
  window.shdSpacingRun = run;
  /* Debug: Console mein shdDebug(10) likho, wo section ka sabse upar/neeche wala naap-element dikhega */
  window.shdDebug = function (i) {
    console.log('section ' + i, LAST[i]);
    console.log('section ' + (i - 1), LAST[i - 1]);
  };

  function init() {
    run();
    setTimeout(run, 500);
    setTimeout(run, 1500);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { later(50); });
    window.addEventListener('load', function () { later(50); });
    window.addEventListener('resize', function () { later(200); });
    document.addEventListener('load', function () { later(150); }, true);
    document.addEventListener('shopify:section:load', function () { later(300); });
    document.addEventListener('shopify:section:unload', function () { later(300); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
